export enum HttpStatus {
    OK = 200,
    CREATED = 201,
    NOT_FOUND = 404,
    GONE = 410,
    UNAUTHORIZED = 401,
    INTERNAL_SERVER_ERROR = 500,
    CONFLICT = 409
}
